"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialCategoryPageFragment = void 0;
var _fetching = require("@ori/fetching");
var _editorialPageFragment = require("./editorialPageFragment");
const editorialCategoryFragment = (0, _fetching.gql)`
  fragment EditorialCategory on EditorialLandingPage {
    landingPageId
    imageUrl
    thumbnailUrl
    description
    themeTag
    link {
      relativeUrl
    }
  }
`;
const editorialCategoryPageFragment = exports.editorialCategoryPageFragment = (0, _fetching.gql)`
  ${editorialCategoryFragment}
  ${_editorialPageFragment.editorialPageFragment}
  fragment EditorialCategoryPage on Application {
    editorialLandingPage(channelType: Web, landingPageId: $pageId) {
      landingPageId
      imageUrl
      thumbnailUrl
      description
      themeTag
      editorialItems {
        ...EditorialPage
      }
      backgroundStorybookColor
      headlineStorybookColor
      themeItems @include(if: $includeThemeItems) {
        ...EditorialCategory
      }
    }
    rootEditorialLandingPage: editorialLandingPage(channelType: Web, landingPageId: $landingPageId)
      @include(if: $includeRoot) {
      themeItems {
        ...EditorialCategory
      }
    }
  }
`;
